import { ContainerComponent, wrap, today } from 'AppReact';
import { DayText, WeekText } from './atoms';
import Controller from './controller';
import { ColumnWrapper, FullWidthFlexboxCentered } from 'wrappers';
import { calendarDates, monthNames, weekdays } from './helpers';
import { isSameDay, subDays } from 'date-fns';
import internalState from './internalState';
import { PrimaryTextBaseBold } from 'atoms';
import { CalendarCellWrapper } from './wrappers';

export const definition = {
  name: 'Calendar',
  controller: Controller,
  initialProps: ({ selectedPeriod, disabledBefore, disabledAfter, selectedDates, month, year, dateMarginTop, showToday }) => ({ selectedPeriod, disabledBefore, disabledAfter, selectedDates, month, year, dateMarginTop, showToday }),
  props: internalState,
  elements: [
    {
      component: PrimaryTextBaseBold,
      name: 'CalendarDate',
      displayValue: ({ month, year }) => `${monthNames[month]} ${year}`
    },
    {
      name: 'HeaderRow',
      wrapper: FullWidthFlexboxCentered,
      elements: [
        {
          name: 'WeekDayName',
          component: wrap(WeekText, CalendarCellWrapper),
          isListOf: weekdays,
          displayValue: ({ _listItem }) => _listItem,
        }
      ]
    },
    {
      name: 'Dates',
      wrapper: FullWidthFlexboxCentered,
      elements: [
        {
          wrapper: CalendarCellWrapper,
          isListOf: { date: ({ month, year }) => calendarDates(new Date(year, month)) },
          displayState: ({ date, selectedPeriod, dateMarginTop }) => {
            const inSelectedPeriod = selectedPeriod && selectedPeriod[0] <= date && date <= selectedPeriod[1];
            const roundedLeft = selectedPeriod?.[0] && isSameDay(date, selectedPeriod[0]);
            const roundedRight = selectedPeriod?.[1] && isSameDay(date, selectedPeriod[1]);
            return { inSelectedPeriod, roundedLeft, roundedRight, dateMarginTop }
          },
          name: 'CellWrapper',
          elements: [
            {
              name: 'Day',
              component: DayText,
              renderIf: ({ month, date }) => date.getMonth() === month,
              displayValue: ({ date }) => date.getDate(),
              displayState: ({ date, selectedDates, disabledBefore, disabledAfter, showToday }) => {
                const selected = !!selectedDates?.find(d => isSameDay(date, d));
                const disabled = (disabledBefore && date < subDays(disabledBefore, 1)) || (disabledAfter && date > disabledAfter);
                return { selected, disabled, isToday: showToday && isSameDay(date, today()) }
              },
              bindings: ({ date, disabledAfter, disabledBefore }) => ({ date, disabled: (disabledBefore && date < subDays(disabledBefore, 1)) || (disabledAfter && date > disabledAfter) })
            }
          ]
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), ColumnWrapper);